import { type H3Event, getRequestHeader } from 'h3'

import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

/**
 * Extracts the locale from the Accept-Language header, normalized to BCP 47,
 * or null if the header is missing or isn't a usable single locale tag
 * (lists like "es-US,en;q=0.9" or partial tags like "es" are rejected).
 */
export function getLocaleFromAcceptLanguage(
  event: H3Event,
): Bcp47Locale | null {
  const acceptLanguageHeader = getRequestHeader(event, 'Accept-Language')

  if (!acceptLanguageHeader) return null

  try {
    return toBcp47Locale(acceptLanguageHeader)
  } catch {
    return null
  }
}
